import { useLayoutEffect, useRef, useState } from 'react';

/**
 * Measure the height of a card element and keep it in sync with resizes.
 * Returns a ref to attach to the element and the measured height.
 */
export function useCardHeight(
  isMobile: boolean,
  carouselRadius: number,
  initialHeight = 0,
) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(initialHeight);

  useLayoutEffect(() => {
    if (isMobile) return;
    const node = ref.current;
    if (!node) return;

    let raf = 0;
    const measure = () => {
      const rect = node.getBoundingClientRect();
      if (rect.height > 0) {
        setHeight(rect.height);
      } else {
        raf = requestAnimationFrame(measure);
      }
    };

    raf = requestAnimationFrame(measure);
    const observer = new ResizeObserver(() => measure());
    observer.observe(node);
    return () => {
      cancelAnimationFrame(raf);
      observer.disconnect();
    };
  }, [isMobile, carouselRadius]);

  return { ref, height } as const;
}
